export const CRICKET_BASE_URL = process.env.REACT_APP_CRICKET_URL;
export const TENNIS_BASE_URL = process.env.REACT_APP_TENNIS_URL;
export const TENNIS_BASE_URL_NEW = process.env.REACT_APP_TENNIS_URL;
export const SOCCER_BASE_URL = process.env.REACT_APP_SOCCER_URL;
export const HORCE_RACING_BASE_URL = process.env.REACT_APP_HORCE_RACING_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const autoSettleFor = ["Over By Over", "Normal"];
